import { Component } from '@angular/core';
import { SalesComponent } from '@src/base-components/sales/sales.component';

@Component({
    selector: 'app-sales',
    templateUrl: '../../../base-components/sales/sales.component.html',
    styleUrls: ['../../../base-components/sales/sales.component.scss']
})

export class SalesOrisComponent extends SalesComponent { }